/* eslint-disable @typescript-eslint/no-explicit-any */
import { getDateDifferenceInDays } from '../../../../../../../util/utilityFunctions';

export const getIconByDate = (expirationDate: any): string => {
  const diffDays = getDateDifferenceInDays(
    new Date(expirationDate).toString(),
    new Date().toString()
  );

  if (diffDays < 0) return 'warning';
  if (diffDays < 30) return 'clock';
  if (diffDays < 90) return 'notification';

  return '';
};
